module.exports = __webpack_public_path__ + "c4649fdeb49fa5d56b3e611cd49d1c0d.png";